import React from 'react';

import {useSnackbar} from 'notistack';
import {useHistory} from 'react-router-dom';

import {Messages, SnackbarVariants} from 'commons/constants';
import {MainContent} from 'layouts/commons';
import {useFlowFieldSearch, useSpinner} from 'hooks';
import ProfileInfoForm from './profile-info-form/ProfileInfoForm';
import {nextStep} from 'commons/utils/Functions';
import {useMenuContext} from 'context/onboarding-menu/OnboardingMenu';
import {useFlowContext} from 'context/onboarding-flow/OnboardingFlow';
import {TransactionalProfileServiceRequest, Field, EfeResponse} from 'commons/models';
import {ClientService} from 'services';

function RegulatoryFramework() {
    const history = useHistory();
    const {flow} = useFlowContext();
    const {enqueueSnackbar} = useSnackbar();
    const [fields, setFields] = React.useState<Array<Field>>(useFlowFieldSearch());
    const {menu, expedientId, fatherKycId} = useMenuContext();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [profile, setProfile] = React.useState<any>();

    React.useEffect(() => {
        if (fatherKycId > 0) {
            setIsLoading(true);
            (async function () {
                try {
                    const response: EfeResponse<TransactionalProfileServiceRequest> =
                        await ClientService.getTransactionalProfile(fatherKycId, expedientId);
                    if (response && response.data) {
                        setProfile(response.data);
                    }
                    setIsLoading(false);
                } catch (error) {
                    setIsLoading(false);
                    setProfile(undefined);
                }
            })();
        }
    }, []);

    async function onSubmit(values: TransactionalProfileServiceRequest) {
        const request = {...values};
        setIsLoading(true);
        try {
            request.kycId = fatherKycId;
            request.viewId = flow.data.viewId;
            request.expedientId = expedientId;
            request.viewFatherId = flow.data.fatherId;
            const response: EfeResponse<TransactionalProfileServiceRequest> =
                await ClientService.saveTransactionProfile(request);
            if (response && response.data) {
                const path = nextStep(flow, menu, true);
                setFields([...fields]);
                setIsLoading(false);
                history.push(path);
            } else {
                setFields([...fields]);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            setFields([...fields]);
            enqueueSnackbar(Messages.ERROR_SAVING_INFORMATION, {
                variant: SnackbarVariants.ERROR,
            });
        }
    }

    return (
        <div>
            <MainContent>
                {isLoading && useSpinner(isLoading)}
                {!isLoading && (
                    <ProfileInfoForm
                        fields={fields}
                        title={flow.data.name}
                        isLoading={isLoading}
                        submitHandler={onSubmit}
                        profile={profile}
                    />
                )}
            </MainContent>
        </div>
    );
}

export default RegulatoryFramework;
